/**
 * Get all account numbers between 1000-9999.
 */
export const getAllAccountNumbers = (): string[] =>
  Array.from({ length: 9000 }, (_, i) => (i + 1000).toString())
